module.exports = "<login-cars-now ng-if=\"!$ctrl.appConfig.isLeadManager\"></login-cars-now>\r\n<login-lead-manager ng-if=\"$ctrl.appConfig.isLeadManager\"></login-lead-manager >"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/login/login.html
// module id = 1017
// module chunks = 0